import AbstractComponent from './AbstractComponent';
import Menu from './Menu';
import ResizeManager from '../managers/ResizeManager';
import ScrollManager from '../managers/ScrollManager';

class Header extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.handleClickToggle = this.handleClickToggle.bind(this);
  }

  getUI() {
    const ui = super.getUI();
    ui.$menu = ui.$element.querySelector('.menu');
    ui.$logo = ui.$element.querySelector('.header__logo');
    ui.$toggle = ui.$element.querySelector('.header__toggle-menu');
    return ui;
  }

  initialize() {
    this.isScrolled = false;
    this.isHomeScrolled = false;
    this.isHome = document.body.classList.contains('home');
    this.menu = new Menu({ $element: this.ui.$menu });
  }

  events(listen) {
    super.events(listen);
    const method = listen ? 'addEventListener' : 'removeEventListener';
    this.ui.$toggle[method]('click', this.handleClickToggle);
  }

  handleClickToggle(event) {
    this.menu.toggle();
  }

  handleResize(width, height) {
    if (!this.isHome) return false;
    this.homeColorLimit = height - this.ui.$element.offsetHeight / 2;
    this.logoHeight = this.ui.$logo.offsetHeight;
    this.handleScroll();
  }

  handleScroll(scrollTop = ScrollManager.scrollTop) {
    if (scrollTop > 0 && this.isScrolled === false) {
      document.body.classList.add('is-scrolled');
      this.isScrolled = true;
    } else if (scrollTop <= 0 && this.isScrolled === true) {
      document.body.classList.remove('is-scrolled');
      this.isScrolled = false;
    }

    if (!this.isHome) return false;

    if (scrollTop > this.homeColorLimit && this.isHomeScrolled === false) {
      document.body.classList.add('is-home-scrolled');
      this.isHomeScrolled = true;
    } else if (scrollTop < this.homeColorLimit && this.isHomeScrolled === true) {
      document.body.classList.remove('is-home-scrolled');
      this.isHomeScrolled = false;
    }

    const top = Math.max(0, ResizeManager.height / 2 - scrollTop - this.logoHeight);
    this.ui.$logo.style.transform = `translateY(${top}px)`;
    this.ui.$logo.style.opacity = 1;
  }
}

export default Header;
